import React from "react";
import { Stack } from "@mui/material";
import {
  deleteBRECompanyLeaseDocument,
  downloadBRECompanyLeaseDocument,
  uploadBRECompanyLeaseDocument,
} from "./BRECompanyAPI";
import { downloadBlobFile } from "./BRECompanyHelpers";
import CompanyDocumentsPanel from "../../../shared/components/CompanyDocumentsPanel";

const LEASE_DOCUMENT_LABELS = {
  description: "Upload one or more PDF lease documents for this company.",
  title: "Lease Documents",
  emptyMessage: "No lease documents uploaded yet.",
  invalidTypeMessage: "Lease document must be uploaded as a PDF.",
  uploadErrorMessage: "Failed to upload lease document.",
  downloadErrorMessage: "Failed to download lease document.",
  viewErrorMessage: "Failed to open lease document.",
  deleteErrorMessage: "Failed to delete lease document.",
  previewTitle: "Loading lease document...",
  defaultFileName: "lease-document.pdf",
  deleteButtonLabel: "Remove",
};

function BRECompanyLeaseDocumentsTab({ companyId, company, onCompanyUpdated }) {
  return (
    <Stack spacing={2}>
      <CompanyDocumentsPanel
        companyId={companyId}
        documents={company?.lease_documents}
        uploadedAt={company?.lease_document_uploaded_at}
        labels={LEASE_DOCUMENT_LABELS}
        onUpload={uploadBRECompanyLeaseDocument}
        onDownload={downloadBRECompanyLeaseDocument}
        onDelete={deleteBRECompanyLeaseDocument}
        onCompanyUpdated={onCompanyUpdated}
        downloadBlobFile={downloadBlobFile}
      />
    </Stack>
  );
}

export default BRECompanyLeaseDocumentsTab;
